import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent {
  @Input() icon = "arrow";
  @Input() backgroundColor: '#3E92CC' | '#2AAE3F' = '#3E92CC';
  @Input() title: string = ''
  @Input() warning: number = 0;
  @Input() orange: number = 0;
  @Input() danger: number = 0;
  @Input() collapse: boolean = false;

  constructor() { }

  toggle() {
    this.collapse = !this.collapse;
  }
}
